export const formDataToObject = (formData) => {
  const object = {};

  formData.forEach((value, key) => {
    if (key.includes('[]')) {
      const arrayKey = key.split('[]')[0];
      
      if (object[arrayKey]) {
        object[arrayKey].push(value);
      } else {
        object[arrayKey] = [value];
      }
     } else {
      object[key] = value;
    }
  });

  return object;
}
